import { render } from "./KelimeSayisi.vue?vue&type=template&id=981ea6ca"
import script from "./KelimeSayisi.vue?vue&type=script&lang=js"
export * from "./KelimeSayisi.vue?vue&type=script&lang=js"

import "./KelimeSayisi.vue?vue&type=style&index=0&id=981ea6ca&lang=css"

import exportComponent from "../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__